import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import { CompletionProgressBar } from './CompletionProgressBar';

export const progressQueryKey = (contractId, projectId) => (projectId
    ? ['completionProgress', 'project', projectId]
    : ['completionProgress', 'contract', contractId]);

export const ContractProjectProgressBar = ({
    contractId, projectId, label, className, canViewDetails,
}) => {
    const { data: progress, isLoading } = useQuery({
        queryKey: progressQueryKey(contractId, projectId),
        queryFn: () => (projectId
            ? httpClient.js(ApiRoutes.project.progress(projectId))
            : httpClient.js(ApiRoutes.contract.progress(contractId))),
        enabled: Boolean(projectId || contractId),
    });

    return (
        <CompletionProgressBar
            progress={progress}
            loading={isLoading}
            label={label}
            className={className}
            canViewDetails={canViewDetails}
        />
    );
};
